export default "__VITE_ASSET__CvAqiV0t__"